import apiClient from "../utils/axiosConfig";
import { getApiUrl, API_ENDPOINTS } from "../Configurations/config";

/**
 * Supervisor Service - wraps supervisor-only access gate.
 * Requires Databricks Bearer token (wired via axios interceptors).
 */
class SupervisorService {
  /**
   * POST /api/supervisor/check-access
   * @param {string} email
   * @returns {Promise<{access_granted:boolean,email:string,message:string}>}
   */
  async checkAccess(email) {
    const payload = { email };
    const url = getApiUrl(API_ENDPOINTS.SUPERVISOR.CHECK_ACCESS);
    const response = await apiClient.post(url, payload);
    return response.data;
  }
}

export const supervisorService = new SupervisorService();
export default supervisorService;

